import { useContext, useEffect, useRef } from 'react';
import Axios from 'axios';
import { CartContext } from '../cart/ContextProvider';
import OrderSuccess from './orderSuccess';
import { useNavigate } from 'react-router';

// Function to load script and append in DOM tree.
const loadScript = src => new Promise((resolve) => {
  const script = document.createElement('script');
  script.src = src;
  script.onload = () => {
    console.log('razorpay loaded successfully');
    resolve(true);
  };
  script.onerror = () => {
    console.log('error in loading razorpay');
    resolve(false);
  };
  document.body.appendChild(script);
});


const RenderRazorpay = ({
  orderId,
  keyId,
  keySecret,
  currency,
  amount,
}) => {

  const { setDisplayRazorpay, userId, cartId,  setInitialLoading, setOrderSuccess ,setCounter, setTotalPrice, setCartItems} = useContext(CartContext);
  const paymentId = useRef(null);
  const paymentMethod = useRef(null);
  const navigate = useNavigate();


  // To load razorpay checkout modal script.
  const displayRazorpay = async (options) => {

    


    const res = await loadScript(
      'https://checkout.razorpay.com/v1/checkout.js',
    );

    if (!res) {
      console.log('Razorpay SDK failed to load. Are you online?');
      return;
    }
    // All information is loaded in options which we will discuss later.
    const rzp1 = new window.Razorpay(options);


    // If you want to retreive the chosen payment method.
    rzp1.on('payment.submit', (response) => {
      paymentMethod.current = response.method;
    });

    // To get payment id in case of failed transaction.
    rzp1.on('payment.failed', (response) => {
      paymentId.current = response.error.metadata.payment_id;
      setDisplayRazorpay(false)


    });

    // to open razorpay checkout modal.
    rzp1.open();

  };


  // informing server about payment
  const handlePaymentVerification = async (response) => {
    try {
      console.log("payment function entered");
      setInitialLoading(true)
      const res = await Axios.post(`https://jackpotbackend.vercel.app/payment/verification`,
        {
          paymentId: response.razorpay_payment_id,
          orderId: response.razorpay_order_id,
          signature: response.razorpay_signature,
          userId: userId,
          cartId: cartId
        });

        setCartItems([]);

        setCounter(0);
        setTotalPrice(0);
        setInitialLoading(false)
        setOrderSuccess(true);


    } catch (error) {
      console.log("error" + error);
    }
  };



  var options = {
    key: 'rzp_test_KZCCFL4O7PCUmu', // Enter the Key ID generated from the Dashboard
    one_click_checkout: false,
    name: "Jackpot", //your business name
    order_id: orderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
    show_coupons: true, // default true; false if coupon widget should be hidden
    handler: (response) => { handlePaymentVerification(response) },
    prefill: { //We recommend using the prefill parameter to auto-fill customer's contact information, especially their phone number
      name: "Gaurav Kumar", //your customer's name
      email: "gaurav.kumar@example.com",
      contact: "9087851444"  //Provide the customer's phone number for better conversion rates 
    },

    notes: {
      address: "Razorpay Corporate Office"
    },
    config: {
      display: {
        blocks: {
          banks: {
            name: 'All payment methods',
            instruments: [
              {
                method: 'upi'
              },
              {
                method: 'card'
              },
              {
                method: 'wallet'
              },
              {
                method: 'netbanking'
              },
              {
                method: 'paylater'
              }
            ],
          },
        },
        sequence: ['block.banks'],
        preferences: {
          show_default_blocks: false,
        },
      },
    },

  };

  useEffect(() => {
    console.log('in razorpay');
    displayRazorpay(options);
  }, []);



  return null;
};

export default RenderRazorpay;